<template>
  <el-container class="WarrantyPrint">
    <el-main class="p-0 pb-default">
      <div class="flex space-between">
        <div class="page-subtitle">품질보증서</div>
        <div>
          <el-button
            type="primary"
            @click="handleClickPrint('1')"
          >{{$t('button.print')}}</el-button>
        </div>
      </div>
      <div class="of-auto" style="height: 250px">
        <div ref="warranty">
          <QRWarranty 
            v-for="(good, index) in goods"
            :key="index"
            :config="config.warranty" 
            :data="good"
          />
        </div>
      </div>
      <div class="mt-default flex space-between">
        <div class="page-subtitle">컨트롤스티커</div>
        <div>
          <el-button
            type="primary"
            @click="handleClickPrint('2')"
          >{{$t('button.print')}}</el-button>
        </div>
      </div>
      <div class="of-auto" style="height: 120px">
        <div ref="control">
          <BarcodeControl 
            v-for="(good, index) in controlGoods"
            :key="index"
            :config="config.control" 
            :data="good"
          />
        </div>
      </div>
      <div class="mt-default flex space-between">
        <div class="page-subtitle">박스스티커</div>
        <div>
          <el-button
            type="primary"
            @click="handleClickPrint('3')"
          >{{$t('button.print')}}</el-button>
        </div>
      </div>
      <div class="of-auto" style="height: 180px">
        <div ref="box">
          <BarcodeBox 
            v-for="(good, index) in goods"
            :key="index"
            :config="config.box" 
            :data="good"
          />
        </div>
      </div>
      <div class="mt-default flex space-between">
        <div class="page-subtitle">출고스티커</div>
        <div>
          <el-button
            type="primary"
            @click="handleClickPrint('4')"
          >{{$t('button.print')}}</el-button>
        </div>
      </div>
      <div class="of-auto" style="height: 240px">
        <div ref="out">
          <BarcodeOut
            v-for="(product, index) in products"
            :key="index"
            :config="config.out" 
            :data="product"
          />
        </div>
      </div>
      <el-dialog
        title="인쇄 옵션"
        top="120px"
        width="300px"
        :visible.sync="dialog_visible"
        :close-on-click-modal="false"
        :modal="false"
        destroyOnClose
      >
        <PrintConfig 
          ref="config" 
          v-if="dialog_visible" 
          @completed="handleCompletedPrintConfig" 
        />
      </el-dialog>
    </el-main>
    <el-footer>
      <el-button
        @click="handleClickPrintConfig"
      >인쇄 옵션</el-button>
      <el-button @click="closeDialog" class="right">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>
<script>
import Vue from 'vue'
import { mapGetters } from "vuex";
import Print from '@/plugins/print/print'
import { print_config } from '@/common/mixins/print_config'
import QRWarranty from '@/spa/Common/QRWarranty'
import BarcodeControl from '@/spa/Common/BarcodeControl'
import BarcodeBox from '@/spa/Common/BarcodeBox'
import BarcodeOut from '@/spa/Common/BarcodeOut'
import PrintConfig from '@/spa/Common/PrintConfig'

Vue.use(Print);

export default {
  name: "PrintView",
  mixins: [print_config],
  components: {QRWarranty, BarcodeControl, BarcodeBox, BarcodeOut, PrintConfig },
  data() {
    return {
      activeTab: "1",
      products: [],
      details: [],
      goods: [],
      contract: undefined,
      dialog_visible: false,
      config: {},
    }
  },
  props: {
    data: {
      type: Object,
      default: function() { return {}; }
    },
  },
  computed: {
    ...mapGetters(["table_product"]),
    controlGoods() {
      return this.goods.length > 0? this.goods: this.details;
    },
  },
  watch: {
    data: function() {
      this.loadData();
    }
  },
  mounted() {
    this.loadConfig();
    this.loadData();
  },
  methods: {
    loadConfig() {
      let item = this.loadPrintConfig();
      if (!item) { return; }
      this.util.copyObject(item.value, this.config);
    },
    loadData() {
      this.api.selectContractDeteail(this.data.contract_detail_id).then(res => {
        this.details = res.data.goods;
        this.api.selectContract(res.data.contract_id).then(res => {
          this.contract = res.data;
          this.organizeData();
        });
      });
    },   
    organizeData() {
      let goods = [];
      let details = [];
      let products = [];
      details.push({
        customer_name: this.contract.customer_name,
        contract_code: this.contract.code,
      });
      this.contract.details.forEach(detail => {
        products.push({
          contract_code: this.contract.code,
          customer_name: this.data.customer_name,
          contract_date: this.contract.contract_date,
          product_name: detail.product_name,  
        });
        let specification = this.util.getSpecification(detail, this.contract.details);
        detail.goods.forEach(good => {
          goods.push({
            code: good.code,
            contract_code: this.contract.code,
            customer_name: this.data.customer_name,
            contract_date: this.contract.contract_date,
            delivery_date: this.data.delivery_date,
            product_id: detail.product_id,
            field: detail.field,
            desc: detail.desc,
            size: good.size,
            sizes: this.getSize(good),
            specification: specification,
          });
        });
      });
      this.goods = goods;
      this.details = details;
      this.products = products;
    },
    getSize(good) {      
      let product = this.table_product.find(p => p.id === good.product_id);
      return this.util.calculateSize(good.size, product);
    },
    closeDialog() {
      this.$emit('completed');
    },
    handleClickPrint(target) {
      switch(target) {
        case '1':
          this.$print(this.$refs.warranty);
          break;
        case '2':
          this.$print(this.$refs.control);
          break;
        case '3':
          this.$print(this.$refs.box);
          break;
        case '4':
          this.$print(this.$refs.out);
          break;          
      }
    },
    handleClickPrintConfig() {
      this.dialog_visible = true;
    },
    handleCompletedPrintConfig() {
      this.dialog_visible = false;
      this.loadConfig();
    },
  }
}
</script>
<style lang="scss" scoped>
.print-area {
  height: 200px;
  overflow: auto;
}
</style>